// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3CNut","bigColWidth":"Table_bigColWidth__pmriI","biggerColWidth":"Table_biggerColWidth__32aUP","row":"Table_row__Om2YQ","col":"Table_col__3Rqz4"};